/** Droits détaillés (Partie C) — groupés comme dans la maquette « Ajouter un utilisateur ». */

export const PERM_GROUPS = [
  {
    key: "dashboard", title: "Dashboard", perms: [
      { key: "view_dashboard", label: "Voir le dashboard" },
      { key: "view_profit", label: "Voir le bénéfice et les marges", sensitive: true },
      { key: "view_cash", label: "Voir la trésorerie", sensitive: true, hint: "Soldes et mouvements de caisse" },
      { key: "view_advanced", label: "Voir « Voir plus » (analyses)", sensitive: true, hint: "Palier Business et plus" },
    ],
  },
  {
    key: "sales", title: "Ventes", perms: [
      { key: "sales_create", label: "Créer une vente" },
      { key: "sales_view_all", label: "Voir toutes les ventes de l'entreprise", hint: "Sinon, uniquement les siennes" },
      { key: "sales_credit", label: "Vendre à crédit" },
      { key: "sales_collect", label: "Encaisser un paiement client" },
      { key: "sales_cancel", label: "Annuler ou modifier une vente" },
      { key: "docs_create", label: "Devis, factures, bons de livraison" },
    ],
  },
  {
    key: "stock", title: "Stock", perms: [
      { key: "products_view", label: "Voir les produits" },
      { key: "products_view_cost", label: "Voir le prix d'achat et la marge", sensitive: true },
      { key: "products_manage", label: "Créer ou modifier un produit" },
      { key: "products_price", label: "Modifier le prix de vente" },
      { key: "stock_receive", label: "Réceptionner du stock" },
      { key: "stock_correct", label: "Corriger le stock", hint: "Inventaire physique, motif obligatoire" },
      { key: "stock_production", label: "Entrée de production" },
    ],
  },
  {
    key: "parties", title: "Clients et fournisseurs", perms: [
      { key: "clients_view", label: "Clients : voir et créer" },
      { key: "clients_receivables", label: "Voir les créances clients" },
      { key: "suppliers_view", label: "Fournisseurs : voir et créer" },
      { key: "suppliers_pay", label: "Payer une dette fournisseur" },
    ],
  },
  {
    key: "expenses", title: "Dépenses", perms: [
      { key: "expenses_view", label: "Voir et enregistrer des dépenses" },
      { key: "expenses_edit", label: "Modifier ou supprimer une dépense" },
      { key: "expenses_cancel", label: "Annuler une dépense", hint: "Motif obligatoire, tracé dans le journal" },
    ],
  },
  {
    key: "tools", title: "Assistant, alertes et exports", perms: [
      { key: "ai_use", label: "Assistant IA", hint: "Ne répond jamais au-delà des droits de la personne" },
      { key: "alerts_stock", label: "Alertes de stock" },
      { key: "alerts_debts", label: "Alertes de créances et de dettes" },
      { key: "export_excel", label: "Export Excel et rapports", sensitive: true },
    ],
  },
];

export const PATRON_ONLY = [
  "Salaires et RH",
  "Équipe et permissions",
  "Abonnement et paiement",
  "Archivage et suppression de produits",
  "Journal d'audit et paramètres de l'entreprise",
];

export const ALL_PERM_KEYS = PERM_GROUPS.flatMap((g) => g.perms.map((p) => p.key));

export const PERM_LABEL_BY_KEY = Object.fromEntries(
  PERM_GROUPS.flatMap((g) => g.perms.map((p) => [p.key, p.label])),
);

const PRESETS = {
  gestionnaire: ["view_dashboard", "sales_create", "sales_view_all", "sales_credit", "sales_collect",
    "sales_cancel", "docs_create", "products_view", "products_view_cost", "products_manage",
    "products_price", "stock_receive", "stock_correct", "stock_production", "clients_view",
    "clients_receivables", "suppliers_view", "suppliers_pay", "expenses_view", "ai_use",
    "alerts_stock", "alerts_debts"],
  vendeur: ["sales_create", "sales_view_all", "sales_collect", "docs_create", "products_view",
    "clients_view", "ai_use", "alerts_stock"],
};

export function presetPerms(role) {
  const on = new Set(PRESETS[role] || PRESETS.vendeur);
  return Object.fromEntries(ALL_PERM_KEYS.map((k) => [k, on.has(k)]));
}

export function matchesPreset(perms, role) {
  const p = presetPerms(role);
  return ALL_PERM_KEYS.every((k) => !!perms?.[k] === p[k]);
}
